/**
 * A new account carries "-" as first and last name until the customer's
 * first booking writes the real name (see PaymentProcessAction). Some
 * screens normalise "-" to "" before storing the user, so both count as
 * "no name yet".
 */
export const isPlaceholderName = (name?: string | null): boolean =>
    !name || name.trim() === "" || name.trim() === "-";

/** True when at least one of the two names still needs the real value. */
export const hasPlaceholderName = (
    user?: { firstName?: string | null; lastName?: string | null } | null
): boolean => isPlaceholderName(user?.firstName) || isPlaceholderName(user?.lastName);
